import React from 'react';

import BlockAccessPage from '../../../../../components/BlockAccess/BlockAccessPage';
import WasteTable from '../../../../../components/Table/WasteTable';
import {accessModule} from '../../../../../store/companyStore/companyDetailsStore';
import {shouldBlockModuleAccess} from '../../../../../utils/SubscriptionHelper';

const Waste: React.FC<{selectedYear: string; facilityId: string}> = ({
  selectedYear,
  facilityId
}) => {
  return shouldBlockModuleAccess(accessModule.scope3) ? (
    <BlockAccessPage />
  ) : (
    <WasteTable selectedYear={selectedYear} facilityId={facilityId} />
  );
};

export default Waste;
